export default api => ({
  loadOptions: () => api.get('/report_parameters'),
  createSample: (lang, params) => api
    .get(`/external_trade_data/${lang}`, {
      params,
    }),
})
